import { FC } from 'react'
import { AppBar, Toolbar as MuiToolbar, styled, AppBarProps } from '@mui/material'
import { HEADER_HEIGHT } from '@client-hub/shared/constants/styles'

const StyledToolbar = styled(MuiToolbar)({
  maxHeight: HEADER_HEIGHT,
  display: 'flex',
  justifyContent: 'space-between',
})

const Toolbar: FC<AppBarProps> = ({ children, sx }) => (
  <AppBar sx={{ ...(sx || {}), zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <StyledToolbar>{children}</StyledToolbar>
  </AppBar>
)

export default Toolbar
